import React from 'react';
import DeleteIcon from 'material-ui-icons/Delete';
import {Tooltip} from 'material-ui';

const actions = ({classes, deletable, deleteSection, changeSectionBgColor}) => (
    <div className={classes.pbSortSectionActions}>
        {deletable && (
            <span className={classes.pbSortSectionActionsDelete}>
                <Tooltip title="Delete Section">
                    <DeleteIcon
                        className="smallIconButtonPages deleteColor"
                        onClick={deleteSection}
                    />
                </Tooltip>
            </span>
        )}
    </div>
);

export default actions;



// WEBPACK FOOTER //
// ./src/containers/builder/sections/tab_dnd/section_actions.js